import React from "react"
import { Outlet, useLocation } from "react-router-dom"
import "../App.css"
import Header from "./Header"
import Menu from "./Menu"

const Layout = () => {
  const location = useLocation()
  return (
    <>
      <Header />
      <Menu />
      <main>
        <div
          className={
            location.pathname === "/work/all" || location.pathname === "/about"
              ? "container-full"
              : "container"
          }
        >
          <Outlet />
        </div>
      </main>
    </>
  )
}

export default Layout
